<div class="main-content" (window:resize)="onResize($event)">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="col-md-12">
                    <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                        <h1 class="h3 mb-0 text-gray-800">Profile <i [popover]="cProfile" class="fas fa-question-circle pointer"></i></h1>
                        <popover-content #cProfile
                                         title="Profile"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Profile</p>
                        </popover-content>

                        <div *ngIf="!isStudent" class="btns-container">
                            <a *ngIf="tabIndex == 0" (click)="saveClient()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-save text-white-50"> <span class="button-text"> Save</span></i>
                            </a>

                            <a *ngIf="tabIndex == 1" (click)="updatePassword()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-save text-white-50"> <span class="button-text"> Change password</span></i>
                            </a>
                        </div>
                    </div>

                        <div class="topSpacing">

                            <div class="desktopTabs" *ngIf="!userInfo.ELICertified && !isStudent">
                                <ul class="tab-nav">
                                    <li (click)="tabSelect(0)" class="active"><a data-toggle="tab" href="#profileTab1">Personal Info</a></li>
                                    <li (click)="tabSelect(1)"><a data-toggle="tab" href="#profileTab2">Change Password</a></li>
                                </ul>
                            </div>

                            <div class="main-tab-content tab-content assessmentsComponent">
                                <div id="profileTab1" class="tab-pane fade in active">
                                    <div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Email:</label>
                                            </div>

                                            <div class="col-md-10">
                                                <input #email
                                                       id="email"
                                                       placeholder="Email"
                                                       type="email"
                                                       (keypress)="preventSpace(email.value, $event, 'email')"
                                                       (keyup)="preventSpace(email.value, $event, 'email')"
                                                       [(ngModel)]="userInfo.email" 
                                                       class="form-control"
                                                       [disabled]="! _Globals.getCanUserEditEmail() ? 'disabled' : null"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>First name:</label>
                                            </div>

                                            <div class="col-md-10">
                                                <input #firstName
                                                       id="firstName"
                                                       placeholder="First name"
                                                       type="text"
                                                       (keypress)="_Globals.allowOnlyNumberAndLetters($event)"
                                                       [(ngModel)]="userInfo.firstName" 
                                                       [disabled]="isStudent ? 'disabled' : null"
                                                       class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Last name:</label>
                                            </div>

                                            <div class="col-md-10">
                                                <input #lastName
                                                       id="lastName"
                                                       placeholder="Last name"
                                                       type="text"
                                                       (keypress)="_Globals.allowOnlyNumberAndLetters($event)"
                                                       [(ngModel)]="userInfo.lastName" 
                                                       [disabled]="isStudent ? 'disabled' : null"
                                                       class="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="profileTab2" class="tab-pane fade">
                                    <div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Current password: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <input passwordDirective class="form-control"
                                                       #_currentPassword
                                                       id="currentPassword"
                                                       type="password"
                                                       name="currentPassword"
                                                       placeholder="Current password"
                                                       autocomplete="new-password"
                                                       [(ngModel)]="userInfo.currentPassword"
                                                       (keyup)="preventSpace(_password1.value, $event, 'currentPassword')" />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>New password: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <input passwordDirective class="form-control"
                                                       #_password1
                                                       id="password1"
                                                       type="password"
                                                       name="password1"
                                                       placeholder="Password"
                                                       autocomplete="new-password"
                                                       [(ngModel)]="userInfo.password1"
                                                       (keyup)="preventSpace(_password1.value, $event, 'password1')"
                                                       (focusout)="confirmationFail()"
                                                       (focusin)="removeMessage()"
                                                       (input)="validForm()" />
                                                <ng9-password-strength-bar [passwordToCheck]="_password1.value"
                                                                           [barColors]="myColors"
                                                                           (onStrengthChanged)="passwordValid($event)">
                                                </ng9-password-strength-bar>
                                                <p id="passWordText" style="font-size: 12px;">
                                                    Your password must be 8-20 characters long and it must contain at least one number, one capital letter and one symbol.
                                                </p>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-2">
                                                <label>Confirm password: </label>
                                            </div>
                                            <div class="col-md-10">
                                                <input passwordDirective class="form-control pass2"
                                                       #_password2
                                                       id="password2"
                                                       type="password"
                                                       name="password2"
                                                       placeholder="Confirm password"
                                                       autocomplete="new-password"
                                                       [(ngModel)]="userInfo.password2"
                                                       (keyup)="preventSpace(_password2.value, $event, 'password2')"
                                                       (focusout)="confirmationFail()"
                                                       (focusin)="removeMessage()" 
                                                       (input)="validForm()"                                                       />
                                            </div>
                                        </div>

                                        <div class="row" style="position: relative; top: -20px;">
                                            <div class="col-md-offset-2 col-md-10">
                                                <span id="errorPasswordMessage"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <br />
                </div>
            </div>
        </div>
    </div>
</div>
